import formRules from './form-rules.json';

export default {
  utils: {
    ...formRules,
  },
};
